/* eslint-disable */
export class AppVersion {public static appVersion='1.0.93';}
